import {Box, Button, Grid, Paper, Typography, TextField} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { useNavigate, useParams } from 'react-router-dom';
import SelectDateField from './SelectDateField';
import SetGuestsField from './SetGuestsField';
import SetCouponField from './SetCouponField';
import SelectDestinationField from './SelectDestinationField';
import {MagnifyingGlass, TicketCoupon, XmarkCircle} from "@vectopus/atlas-icons-react";
import { Close } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import {g, website} from '@/utils/helpers';

const useStyles = makeStyles()((theme) => {
  return {
    rootVP: {
      padding:  0,
      backgroundColor: 'transparent',
      borderRadius: 0,
      boxShadow: 'none'
    },
    box: {
      padding: website.code === 'VP' ? '15px 32px' : 'initial'
    },
    root: {
      backgroundColor: '#FFFFFF',
      padding: '15px 32px',
      boxShadow: '0px 3px 6px #00000029',
      position: 'sticky',
      top: 0,
      zIndex: 9999999
    },
    inputPaper: {
      backgroundColor: website.code === 'VP' ? 'transparent' : '#F5F5F5',
      marginTop: '2px',
      '&:nth-of-type(even)': {
        borderLeft: '2px solid #FFFFFF',
        borderRight: '2px solid #FFFFFF'
      },
      h6: {
        fontFamily: theme.typography.body1.fontFamily
      }
    },
    fieldContent: {
      padding: '8px 5px',
      display: 'inline-flex',
      alignItems: 'center',
      i: {
        fontSize: 23
      },
      h6: {
        fontSize: 14
      }
    },
    couponTextField: {
      borderLeft: '0!important',
      backgroundColor: '#F5F5F5',
      borderRadius: 0,
      marginTop: '2px'
    },
    couponOpenBtn: {
      height: 58,
      textAlign: website.code === 'VP' ? 'left' : 'center',
      verticalAlign: 'middle',
      display: 'flex',
      alignItems: 'center',
      justifyContent: website.code === 'VP' ? 'left' : 'center',
      backgroundColor: website.code === 'VP' ? '#FFF' : '#F5F5F5',
      marginTop: 2,
      paddingLeft: website.code === 'VP' ? '10px' : '0',
      border: website.code === 'VP' ? '1px solid #D9D9D9' : 'none'
    }
  };
});

export const SearchBarMobile = (props: any) => {
  const appContext = useContext(AppContext);


  const { classes } = useStyles();
  const {t} = useTranslation();
  const {search} = useParams();

  const [openModalDatePicker, setOpenModalDatePicker] = useState(false);
  const handleOpenModalDatePicker = () => setOpenModalDatePicker(true);

  const handleCloseModalDatePicker = () => {
    setOpenModalDatePicker(false);
    appContext.getAvailability('search bar mobile');
  };

  const [openGuestsModal, setOpenGuestsModal] = useState(false);
  const handleOpenGuestsModal = () => setOpenGuestsModal(true);

  const value = props.params.value;
  const locale = props.params.locale;
  const container = 'SearchBarMobile';
  const setQuantity = props.params.setQuantity;
  const setPets = props.params.setPets;


  useEffect(() => {
    appContext.setMobileSubmitBtn(true);
  }, [
    appContext.searchForms[appContext.orderIndex].destination,
    appContext.searchForms[appContext.orderIndex].property,
    appContext.searchForms[appContext.orderIndex].typeOfHoliday,
    appContext.searchForms[appContext.orderIndex].landscape,
    appContext.searchForms[appContext.orderIndex].GuestArrival,
    appContext.searchForms[appContext.orderIndex].GuestDeparture,
    appContext.searchForms[appContext.orderIndex].NoOfAdults,
    appContext.searchForms[appContext.orderIndex].ageOfChildren.length,
    appContext.searchForms[appContext.orderIndex].Coupon,
    appContext.searchForms[appContext.orderIndex].Pets
  ]);

  const [couponField, setCouponField] = useState<boolean>(false);

  const handleCouponField = () => {
    setCouponField(!couponField);
  }

  // @ts-ignore
  return (
    <Paper className={website.code === 'VP'? classes.rootVP : classes.root}>
      <Box className={ search && classes.box}>
        {website.code !== 'VP' &&  (
          <SelectDestinationField params={{ container }} />
        )}
        <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'} mt={1} spacing={ website.code === 'VP' ? 1 : 0}>
          <Grid
            size={{
              xs: website.code === 'VP' ? search ? 8 : 12 : 8
            }}
            className={classes.inputPaper}
            onClick={() => handleOpenModalDatePicker()}>
            <Box mb={website.code === 'VP' ? search ? 0 : 1 : 0}>
              <SelectDateField
                params={{ value, locale, handleCloseModalDatePicker, container }}
              />
            </Box>
          </Grid>

          <Grid
            size={{
              xs: 2,
            }}
            className={classes.inputPaper}
            onClick={() => handleOpenGuestsModal()}>
            <SetGuestsField params={{ container, setQuantity, setPets }} />
          </Grid>

          {website.code !== 'VP' ? (
            <Grid
              size={{
                xs: 2,
              }}
              className={classes.couponOpenBtn}
              onClick={handleCouponField}
            >
              <TicketCoupon size={20} />
            </Grid>
            ) : (
              search ? (
                <Grid
                  size={{
                    xs: 2,
                  }}
                  className={classes.couponOpenBtn}
                  onClick={handleCouponField}
                  // styles whit condition for VP searchbar mobile version
                  sx={{
                    paddingLeft:
                      website.code === 'VP'
                        ? (search ? '0!important' : '10px')
                        : '0',

                    justifyContent:
                      website.code === 'VP'
                        ? (search ? 'center!important' : 'left')
                        : 'center',
                  }}
                >
                  <TicketCoupon size={20} />
                </Grid>
              ) : (
                <Grid
                  size={{
                    xs: search ? 2 :10,
                  }}
                  className={classes.couponTextField}
                >
                  <SetCouponField params={{ container }} />
                </Grid>
              )
          )}




          {
            couponField && (
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  md: 12
                }}
                className={classes.couponTextField}
              >
                <SetCouponField params={{ container }} />
              </Grid>
            )
          }


          {
            appContext.mobileSubmitBtn && (
              <Grid
                size={{
                  xs: 12
                }}
                mt={website.code === 'VP' ? search ? 0 : 3 : 1}
              >

                {
                  website.code !== 'VP' ? (
                    <>
                      {
                        !appContext.updateSearch ? (
                          <Button
                            id={'search'}
                            variant={'contained'}
                            type={'submit'}
                            sx={{ backgroundColor: '#000!important', color: '#FFF!important' }}
                            fullWidth>
                            {t('Start_search')}
                          </Button>
                        ) : (
                          <Button
                            id={'search'}
                            variant={'contained'}
                            type={'submit'}
                            sx={{ backgroundColor: '#000!important', color: '#FFF!important' }}
                            fullWidth>
                            {t('Update_search')}
                          </Button>
                        )
                      }
                    </>
                  ) : (
                    <>
                      {
                        !appContext.updateSearch ? (
                          <Button
                            id={'search'}
                            color={'secondary'}
                            variant={'contained'}
                            type={'submit'}
                            fullWidth>
                            {t('Start_search')}
                          </Button>
                        ) : (
                          <Button
                            id={'search'}
                            color={'secondary'}
                            variant={'contained'}
                            type={'submit'}
                            fullWidth>
                            {t('Update_search')}
                          </Button>
                        )
                      }
                    </>
                  )
                }


              </Grid>
            )
          }
        </Grid>
      </Box>
    </Paper>
  );
};
